<template>
  <div class="terms">
    <header class="terms__header">
      <h2>Terms of Use</h2>
      <span>Last updated: March 25, 2024</span>

      <div class="img" @click="$emit('close')">
        <img :src="mediaBaseUrl + 'close.svg'" alt="close">
      </div>
    </header>

    <terms-of-services-text />
  </div>
</template>

<script>
export default {
  name: "PrivacyModal",

  inject: ["mediaBaseUrl"],
}
</script>
